<div class="w-full h-full" *ngIf="fullSize; else minimalSize">
  <div class="flex flex-col w-full h-full bg-[#000] bg-opacity-50">
    <div
      class="flex-none bg-[#3C424A] px-10 py-4 flex flex-row items-center gap-6"
    >
      <div class="flex-grow overflow-hidden">
        <ui-paragraph
          class="whitespace-nowrap text-ellipsis truncate"
          type="p16"
          mobile-type="p16"
          text-color="neutrals-0"
        >
          {{ selectedImage }}
        </ui-paragraph>
      </div>

      <div class="flex gap-4">
        <button type="button" (click)="fullscreen.emit()">
          <ui-icon name="minimize" size="16" m-size="16" fill="neutrals-0" />
        </button>
        <button type="button" (click)="close.emit(closeAll)">
          <ui-icon name="close" size="16" m-size="16" fill="neutrals-0" />
        </button>
      </div>
    </div>

    <div class="flex-grow box-border px-10 flex justify-center items-center">
      <div class="h-[440px] flex justify-center items-center">
        <img
          class="max-w-full max-h-full object-contain"
          [src]="selectedImage"
          alt="Resource central visualizer"
        />
      </div>
    </div>

    <div class="flex justify-center items-center box-border px-10 py-8">
      <div
        class="flex justify-center items-center w-10 h-10 rounded-[4px] overflow-hidden box-border"
      >
        <img
          class="w-[100%] h-[100%]"
          [src]="selectedImage"
          alt="Resource visualizer (mini)"
        />
      </div>
    </div>
  </div>
</div>

<ng-template #minimalSize>
  <div
    class="flex flex-col w-[727px] max-w-[727px] h-[600px] max-h-[600px] absolute top-0 left-0 bg-[#000] bg-opacity-20 rounded-[8px] overflow-hidden"
  >
    <div
      class="flex-none bg-[#3C424A] px-10 py-4 flex flex-row items-center gap-6"
    >
      <div class="flex-grow overflow-hidden">
        <ui-paragraph
          class="whitespace-nowrap text-ellipsis truncate"
          type="p16"
          mobile-type="p16"
          text-color="neutrals-0"
        >
          {{ selectedImage }}
        </ui-paragraph>
      </div>

      <div class="flex gap-4">
        <button type="button" (click)="fullscreen.emit()">
          <ui-icon name="maximize" size="16" m-size="16" fill="neutrals-0" />
        </button>
        <button type="button" (click)="close.emit(false)">
          <ui-icon name="close" size="16" m-size="16" fill="neutrals-0" />
        </button>
      </div>
    </div>

    <div class="flex-grow box-border px-10">
      <div class="h-[440px] flex justify-center items-center">
        <img
          class="max-w-full max-h-full object-contain"
          [src]="selectedImage"
          alt="Resource central visualizer"
        />
      </div>
    </div>

    <div class="flex justify-center items-center box-border px-10 py-8">
      <div
        class="flex justify-center items-center w-10 h-10 rounded-[4px] overflow-hidden box-border"
      >
        <img
          class="w-[100%] h-[100%]"
          [src]="selectedImage"
          alt="Resource visualizer (mini)"
        />
      </div>
    </div>
  </div>
</ng-template>
